import shared from './shared';

/**
 * File Overview
 * Normalization helper object for the body data API
 */

export default {
  normalize(data) {
    const normalizedData = { 'shoeSize': data.recommended_last.size, 'shoeWidth': data.recommended_last.width };

    normalizedData.productMatches = data.recommended_shoes.map((obj, i) => {
      let newObj = {};

      Object.keys(obj.shoe).forEach(prop => {
        newObj[prop] = obj.shoe[prop];
      });

      Object.keys(obj.last).forEach(prop => {
        newObj[prop] = obj.last[prop];
      });

      newObj.id = i;
      newObj.image = obj.shoe.mpl_image_url;
      newObj.description = shared.stripDescription(obj.shoe.mpl_description);
      newObj.url = newObj.url || 'https://www.specialized.com';
      newObj.type = 'shoe';

      return newObj;
    });

    return normalizedData;
  }
}



// WEBPACK FOOTER //
// ./src/client/normalizers/shoe-data-normalizer.js